import { render, staticRenderFns } from "./BlitzarTalk.vue?vue&type=template&id=38e79221&scoped=true"
import script from "./BlitzarTalk.vue?vue&type=script&lang=js"
export * from "./BlitzarTalk.vue?vue&type=script&lang=js"
import style0 from "./BlitzarTalk.vue?vue&type=style&index=0&id=38e79221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e79221",
  null
  
)

export default component.exports